import { CartAddEvent } from '@theme/events';
class addOnProducts extends HTMLElement {
  constructor() {
    super();
    const rawAddOn = this.querySelector('script[type="application/json"]')?.textContent;
    this.addOnJSON = rawAddOn ? JSON.parse(rawAddOn) : null;

    this.addEventListener('submit', this.preHighlight);
    this.addEventListener('modalSubmit', this.preHighlight);

    if (this.addOnJSON) {
      this.renderAddOns();
    } else {
      this.remove();
    }
  }

  preHighlight(e) {
    let addedProduct = e.target.closest('.add-on-product');
    let activatedSet = e.target.closest('.add-on-set');
    addedProduct.classList.add('added');
    activatedSet.classList.add('activated');
  }
  
  renderAddOns() {
    for (const key of Object.keys(this.addOnJSON)) {
      // Create set label
      let addOnSetTitle = document.createElement("div");
      addOnSetTitle.innerHTML = key.replaceAll('-', ' ');
      addOnSetTitle.classList.add('eyebrow', 'sm', 'zero-m');

      // Create set container
      let addOnSet = document.createElement("div");
      addOnSet.classList.add('add-on-set');
      addOnSet.appendChild(addOnSetTitle);
      this.appendChild(addOnSet);

      // fetch html from product.add-on template
      for (const sku of this.addOnJSON[key]) {
        
        fetch(`/search?type=product&view=add-on&q=variants.sku:${sku}`)
          .then(response => response.text())
          .then(body => {
            const html = new DOMParser().parseFromString(body, 'text/html');
            let addOnProduct = html.querySelector(`.add-on-product.sku-${sku}`);
            addOnProduct.querySelector('.choose-options')?.addEventListener('click', this.fetchPDPpopup);
            addOnSet.appendChild(html.querySelector('.add-on-product'));
          })
      }
    }
  }

  fetchPDPpopup(e) {
    const target = e.currentTarget;
    const sectionId = target.closest('[data-section-id]')?.dataset?.sectionId;
    const addOnId = target.closest('.add-on-product')?.dataset?.addOnId;
    console.log('fetchPDPpopup', target.dataset.handle, sectionId);

    // fetch PDP media & buy stack to insert into modal
    fetch(`/products/${e.target.dataset.handle}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(body => {
        // prepare PDP html
        const html = new DOMParser().parseFromString(body, 'text/html');
        const section = html.querySelector('.shopify-section');
        section?.querySelector('.add-on-products')?.remove(); // don't let the recursion happen!
        
        // prepare modal
        let modal = document.createElement('choose-options-modal');
        modal.id = "choose-options-modal";
        modal.setAttribute('data-add-on-id', addOnId);
        modal.appendChild(section);

        document.querySelector('body').appendChild(modal);
      })
  }
}

if (!customElements.get('add-on-products')) {
  customElements.define('add-on-products', addOnProducts);
}

class chooseOptionsModal extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('submit', this.forwardAddEvent.bind(this));
  }

  connectedCallback() {
    let closeButton = document.createElement('div');
    closeButton.classList.add('close-button');
    closeButton.addEventListener('click', this.closeModal.bind(this));

    this.append(closeButton);

    let closeOverlay = document.createElement('div');
    closeOverlay.classList.add('close-overlay');
    closeOverlay.addEventListener('click', this.closeModal.bind(this));

    this.append(closeOverlay);
  }

  closeModal() {
    this.remove();
  }

  forwardAddEvent(e) {
    // trigger the submit event for the original add-on element, if present
    if (this.dataset.addOnId) {
      document.querySelector(`.add-on-product[data-add-on-id=${this.dataset.addOnId}] .choose-options`)
        ?.dispatchEvent(new CustomEvent('modalSubmit', {bubbles: true, detail: e}));
    }

    this.remove();
  }
}

if (!customElements.get('choose-options-modal')) {
  customElements.define('choose-options-modal', chooseOptionsModal);
}